import http from './http.js'
/**
 * post、get、put
 * http.post('url', params, 'query');
 * url:接口
 * params:参数
 * query:传参格式，默认为 data(body)传参，
 *      设置 query 为 params(query)传参，格式为：url?xx=xx
 * queryAndBody: 参数是否包含两个格式  query、body
 *    默认：false,
 *    如果设置为true
 *    参数形式如下，bodyObject内参数会在body传参，params 参数为 url?xxx=xxx
 *    params={
 *      xxx:xxx,
 *      bodyObject:String
 *    }
 */
// 获取聊天记录
export const getChartData = params => {
  return http.get('/api/user/chat-log', params, 'query')
}
// 设置消息为已读
export const setReadMsg = params => {
  return http.post('/api/user/check-un-read-chat-log', params)
}
// 上传文件
export const uploadFile = params => {
  return http.postForm('/sysFileInfo/upload', params)
}
// 获取群信息
export const getGroupDetailApi = params => {
  return http.get(`/api/group/group-by-id/${params.id}`, params)
}
// 解散群
export const deleteGroupApi = params => {
  return http.post('/api/group/delete', params)
}
// 退出群
export const deleteGroupUser = params => {
  return http.post('/api/group/exit-group', params)
}
// 移出成员
export const moveOutGroupUser = params => {
  return http.post('/api/group/move-out-group', params)
}
// 加入群
export const joinGroup = params => {
  return http.post('/api/group/join-group', params)
}
// 创建群
export const createGroup = params => {
  return http.post('/api/group/group', params)
}
// 拉人进群
export const addPeopleToGroup = params => {
  return http.post('/api/group/invite-group', params)
}
// 同步用户数据
export const batchUserData = params => {
  return http.post('/api/user/batch-create-or-update', params)
}
// 判断群组是否已存在
export const isExistGroup = params => {
  return http.get(`/api/group/exist-group/${params.id}/${params.type}`)
}



//////////////////
// WEBPACK FOOTER
// ./packages/api/api.js
// module id = null
// module chunks = 